<template>
  <div>
    <div class="row">
      <div class="col-12">
        <SectionTitle title="Listado de Asistentes de Servicio" />
      </div>
    </div>

    <ServiceAssistantRow
      v-for="(item, index) in results"
      :key="`${index}${componentKey}`"
      v-model="results[index]"
      :collections="collections"
      :academic-year-id="academicYearId"
      :is-open="results[index].isOpen"
      :active-tab="results[index].activeTab"
      :is-not-in-my-school-reason-options="isNotInMySchoolReasonOptions"
      @toggle="(data) => { toggleHandler(data,index) }"
      @save-is-not-in-my-school="handleSaveIsNotInMySchoolReason"
      @revert-is-not-in-my-school="handleRevertIsNotInMySchoolReason"      
    />
  </div>
</template>

<script>
import {
  saveIsNotInMySchoolReason,
  getIsNotInMySchoolReasonOptions,
  revertIsNotInMySchoolReason
} from '@/modules/human-resources/api';

import SectionTitle from "SectionTitle";
import alert from "@/mixin/alert.mixin";
import ServiceAssistantRow from "./ServiceAssistantRow.vue";

export default {
  name: "ServiceAssistantList",
  mixins: [alert],
  components: {
    SectionTitle,
    ServiceAssistantRow
  },
  props: {
    collections: {
      type: Object,
      default: () => ({
        resources: {},
        necessities: [],
        serviceAssistants: []
      })
    },
    academicYearId: { type: [Number, String], default: 0 }
  },
  data() {
    return {
      componentKey: 0,
      isNotInMySchoolReasonOptions: []
    };
  },
  computed: {
    results() {
      return this.collections.serviceAssistants;
    }
  },
  methods: {
    toggleHandler(data, index) {
      var row = this.collections.serviceAssistants[index];
      row.isOpen = data.isOpen;
      row.activeTab = data.activeTab;
      this.componentKey++;
    },
    async populateIsNotInMySchoolReasonOptions() {
      const { data } = await getIsNotInMySchoolReasonOptions();
      this.isNotInMySchoolReasonOptions = data;
    },
    async handleSaveIsNotInMySchoolReason(payload) {
      await saveIsNotInMySchoolReason(payload);
      this.ShowToast("", "", "success");
      this.$emit('reload-list');
    },
    async handleRevertIsNotInMySchoolReason(assistantSchoolId) {
      await revertIsNotInMySchoolReason(assistantSchoolId);
      this.ShowToast("", "", "success");
      this.$emit('reload-list');
    },
  },
  async mounted() {
    await this.populateIsNotInMySchoolReasonOptions();
  }
};
</script>
